
import { AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query, Response } from "../common/hooks/useApi"
import { LoteConsulta } from "../lotes-consulta/useLoteConsultaAPI";
import { ok } from "assert";

export enum TipoDocumento {
  DNI = 0,
  LC = 1,
  LE = 2,
  CI = 3,
  CUIT = 4,
  PAS = 5,
}

export enum TipoTitular {
  OTRO = 0,
  EMPRESA = 1,
  MASCULINO = 2,
  FEMENINO = 3,
}

export interface TitularVehiculo extends Model {
    Lote: LoteConsulta
    PatenteVehiculo: string
    MarcaVehiculo?: string
    ModeloVehiculo?: string
    TipoVehiculo: string
    FechaTransferenciaVehiculo: string
    NombreCompletoTitular: string
    CuilTitular: string
    DireccionCompletaTitular: string
    CodigoPostalTitular: string
    LocalidadTitular: string
    ProvinciaTitular: string
    DocumentoTitular: string
    TipoDocumentoTitular: ("DNI" | "LC" | "LE" | "CI" | "CUIT" | "PAS")
    TipoDocumentoTitularOriginal: string
    DepartamentoTitular: string
    CalleTitular: string
    NroTitular: string
    PisoTitular: string
    DeptoTitular: string
    TipoTitular: ("OTRO" | "EMPRESA" | "MASCULINO" | "FEMENINO")
    Nombre: string
    Apellido: string
    LocalidadTitularOriginal: string
    ProvinciaTitularOriginal: string
    Emails:string;
    TelefonosCelulares: string;
    TelefonosFijo: string;
}

export interface TitularVehiculoCallCenter extends Omit<TitularVehiculo, "TipoDocumentoTitular" | "TipoTitular"> {
  TipoDocumentoTitular: TipoDocumento;
  TipoTitular: TipoTitular;
}


export interface Localidad {
    nombre: string
    departamento?: string
    provincia: string
}

const module = "TitularVehiculo";
export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<TitularVehiculo>(query),
        save: (data: Partial<TitularVehiculo>) => api.save!<Partial<TitularVehiculo>, TitularVehiculo>(data),
        delete: (id: number) => api.delete!<TitularVehiculo>(id),
        queryTitular: async (patente: string, fechaInfraccion: string, diasAntiguedad:number = 0) => {
            try {
                const response = await api.axiosInstance.get<Response<TitularVehiculo[]>>(`${module}/ConsultaLocal?$count=true&patente=${patente}&fechaInfraccion=${fechaInfraccion}&diasantiguedad=${diasAntiguedad}`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        queryLocalidades: async (query: Query) => {
            try {
                let qs = api.queryToString(query);
                const response = await api.axiosInstance.get<Localidad[]>(`${module}/Localidades?${qs}`);
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        editar: async (data:any, titularId:number|string) => {
            try {
                const response = await api.axiosInstance.patch<TitularVehiculo>(`${module}(${titularId})`, data);
                console.log(response);

            } catch (error) {
                console.log(error)
            }
        },
        editarVarios: async (data:any, soloInfraccion: boolean, soloCuit:boolean, soloPatente:boolean) => {
            try {
                console.log(data)
                const response = await api.axiosInstance.post<TitularVehiculo>(`${module}/ActualizarCondicional?soloInfraccion=${soloInfraccion}&soloPatente=${soloPatente}&soloCuit=${soloCuit}`, data);
                console.log(response);
                if(!response.data)
                    throw new Error('');

                return;
            } catch (error) {
                console.log(error)
            }
            throw new Error('');
        }
        /*,
        queryDepartamentos:async (query: Query) => {
            try {
                
                query.$orderby = query.$orderby ?? ["Departamento desc"];

                let qs = api.queryToString({...query,...{$apply:`groupby((departamento))`}});
                
                const response = await api.axiosInstance.get<Localidad[]>(`${module}/Localidades?${qs}`);
                return {
                    data: {value:response.data}
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        queryProvincias:async (query: Query) => {
            try {
                
                query.$orderby = query.$orderby ?? ["Provincia desc"];
                let qs = api.queryToString({...query,...{$apply:"groupby((provincia))"}});
                
                const response = await api.axiosInstance.get<Localidad[]>(`${module}/Localidades?${qs}`);
                return {
                    data: {value:response.data}
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        }*/
    };
}